import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Form, useFormikContext } from 'formik';
import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { useAchievementsContext } from '../../../../contexts/AchievementsContext/AchievementsContext';
import { ConfirmModal } from '../../../ui/ConfirmModal/ConfirmModal';
import { IAchievementModal } from '../AchievementsModalTypes';
import { useAchievementsModalContext } from '../context/AchievementsModalContext';
import { AchievementRowSortable } from './AchievementRowSortable';
import { useAchievementsDragAndDrop } from './useAchievementsDragAndDrop';
import { useConfirmDeleteModal } from './useConfirmDeleteModal';

export function AchievementsForm() {
  const {
    values, setValues, handleSubmit, isSubmitting,
  } = useFormikContext<IAchievementModal[]>();
  const { isFormLoading } = useAchievementsModalContext();
  const { isLoading: isAchievementsLoading } = useAchievementsContext();

  const isFiledSetDisabled = isSubmitting || isFormLoading || isAchievementsLoading;

  const {
    showConfirm,
    confirmDeleteAchievementId,
    handleDeleteConfirm,
    handleOnConfirm,
    handleOnCancel,
  } = useConfirmDeleteModal();

  const {
    sensors,
    collisionDetection,
    handleDragStart,
    handleDragEnd,
  } = useAchievementsDragAndDrop(values, setValues);

  return (
    <Modal.Body>
      <DndContext
        sensors={sensors}
        collisionDetection={collisionDetection}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        <Form onSubmit={handleSubmit}>
          <fieldset disabled={isFiledSetDisabled}>
            <SortableContext
              items={values}
              strategy={verticalListSortingStrategy}
            >
              {/* <DragOverlay modifiers={[restrictToWindowEdges]}> */}
              {values.map((achievement, index) => (
                <AchievementRowSortable
                  key={achievement.id}
                  id={achievement.id}
                  index={index}
                  confirmDelete={handleDeleteConfirm}
                />
              ))}
              {/* </DragOverlay> */}
            </SortableContext>
          </fieldset>
          <ConfirmModal
            centered
            show={showConfirm}
            isLoading={isFiledSetDisabled}
            title="Delete Achievement"
            onConfirm={handleOnConfirm}
            onCancel={handleOnCancel}
            className="overlay"
            backdrop="static"
          >
            <div className="text-center">
              Are you sure you want to delete this achievement?
              <br />
              <b>{values.find((v) => v.id === confirmDeleteAchievementId)?.name ?? 'unknown'}</b>
            </div>
          </ConfirmModal>
        </Form>
      </DndContext>
      {isFiledSetDisabled && (
      <div className="overlay">
        <div className="boxSpinner"><Spinner animation="border" variant="primary" /></div>
      </div>
      )}
    </Modal.Body>
  );
}
